import { z } from 'zod';
import { CareDocumentDataSchema } from '../CareDocumentDataSchema';
import { CareDocumentClinicalAndExperienceOutcomesSchema } from '../CareDocumentClinicalAndExperienceOutcomesSchema';
import { InterimSummaryExpertSummarySchema } from './InterimSummaryExpertSummarySchema';
import { IObject } from '../../../IObject';
import { InterimCareSummarySupportProgressSchema } from './InterimCareSummarySupportProgressSchema';
import { CareDocumentWorkDetailsSchema } from '../CareDocumentWorkDetailsSchema';
import { requiresCaseReferenceNumber } from '../careDocumentChecks';
import {
  dateValidation,
  fullNameValidation,
  requiredString,
} from '../../../../validation';

export const InterimCareSummaryDataSchema = CareDocumentDataSchema.extend({
  patient: z.object({
    fullName: fullNameValidation('Patient name is required'),
    dob: dateValidation('Patient date of birth is required'),
    cancerType: requiredString('Cancer type is required'),
    // dateOfDiagnosis: dateValidation('Date of diagnosis is required'),
    work: CareDocumentWorkDetailsSchema,
    level: z.string().optional(),
  }),
  perciStartDate: dateValidation('Perci Health start date is required'),
  dateOfInterimSummary: dateValidation(
    'Date of interim summary date is required',
  ),

  clinicalAndExperienceOutcomes:
    CareDocumentClinicalAndExperienceOutcomesSchema,

  supportProgress: z.array(InterimCareSummarySupportProgressSchema),

  gip: z.object({
    // Optional: L&G's GIP code. Aviva has none and uses policyNumber instead.
    code: z.string().optional(),
  }),
  policyNumber: z.string().optional(),
  expertFullName: z.string().optional(),
  expertSummary: InterimSummaryExpertSummarySchema,
}).check(requiresCaseReferenceNumber);

export type InterimCareSummaryData = z.infer<
  typeof InterimCareSummaryDataSchema
>;
export type InterimCareSummary =
  IObject.HasIdTimestamped<InterimCareSummaryData>;
